import React from 'react';
import './center-container.scss';

export function CenterContainer({children, className}) {
  return <div className={className}>{children}</div>;
}
